<span class="btn btn-light btn-file" [class.disabled]="uploader.isUploading">
    <ng-template [ngIf]="uploader.isUploading">
        <i class='fas fa-spinner fa-pulse' aria-hidden='true'></i> Anexando
    </ng-template>
    <ng-template [ngIf]="!uploader.isUploading">
        <i class="fas fa-paperclip"></i> Anexar Termo LGPD
    </ng-template>    

    <input type="file" name="inputFile" #inputFile accept=".pdf" ng2FileSelect [uploader]="uploader" [disabled]="uploader.isUploading"/>
</span>